export const getLiveEventProps = (item, now: number = Date.now()) => {
  const startDateTime: number = item.airDateStartTime;
  const endDateTime: number = item.airDateEndTime;
  const airDate = new Date(startDateTime);
  return {
    isLiveEvent: !!startDateTime,
    isLiveEventAiring: now >= startDateTime && now <= endDateTime,
    airDate,
  };
};

export const getWeekDay = (date, language = 'en'): string => {
  return new Intl.DateTimeFormat(language, { weekday: 'long' }).format(date);
};

export const getTime = (date, language = 'en'): string => {
  return new Intl.DateTimeFormat(language, {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  }).format(date);
};

export const numberOfWorkoutsLabel = (i18n, count) =>
  i18n._translate('%{count} Workout', {
    plural: '%{count} Workouts',
    context:
      'Label to tell the user how many workouts are in a series. A series is a set of related workouts that the user completes over several weeks.',
    count,
  });

export const viewSeriesButtonLabel = i18n =>
  i18n._translate('View series', {
    context:
      'Label of a button which opens a popup to view details of a series of related workouts',
  });

export const viewChallengeButtonLabel = i18n =>
  i18n._translate('View challenge', {
    context:
      'Label of a button which opens a popup to view details of a challenge of related workouts',
  });

export const viewWorkoutButtonLabel = i18n =>
  i18n._translate('View workout', {
    context:
      'Label of a button which opens a popup to view details of the workout',
  });

export const viewLiveEventButtonLabel = i18n =>
  i18n._translate('View details', {
    context:
      'Label of a button which opens popup to view details of the live workout',
  });

export const viewUpcomingLiveEventChipLabel = (i18n, weekDay, date, time) =>
  i18n._translate('Airing %{weekDay} %{date}, %{time}', {
    context: 'Label of a chip that show when a live event is airing',
    weekDay,
    date,
    time,
  });

export const viewAiringLiveEventChipLabel = i18n =>
  i18n._translate('LIVE NOW', {
    context: 'Label of a chip that shows when a live event is airing',
  });
